import { Link } from 'react-router'

import { Screen } from '@/components/screen'
import { StatusLine } from '@/features/status-line/status-line'

// Every agent and mail client that can reach the mailbox, once the list
// exists; until then, the status line and where to find app passwords today.
export function Access() {
  return (
    <Screen title="Access">
      <StatusLine />
      <p className="max-w-[60ch] text-[13px] text-muted-foreground">
        The agents and mail clients that can reach your mailbox, with a way to revoke each, arrive here with a later
        release. Until then, app passwords and Gmail accounts are under{' '}
        <Link className="text-primary hover:underline" to="/settings">
          Account
        </Link>
        .
      </p>
    </Screen>
  )
}
